import React, { useContext, useEffect } from 'react';
import styles from './LoginResponse.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import { SessionManagementModal } from '../../components/UI/Modals/SessionManagementModal';
import PinModal from '../login/Pin/PinModal';
import Spinner from '../../shared/Spinner/Spinner';
import { usePrefetchQuery } from '../movies/movieDetails/query';
import { removeSavedContractId } from '../../utils/refetch';

const LoginResponse = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = Object.fromEntries(queryParams.entries());
  const authContext = useContext(AuthContext);
  const [lastPinData, setLastPinData] = React.useState('');
  const navigate = useNavigate();

  const {
    login,
    showModal,
    closeSessionModal,
    confirmPinRequired,
    error,
    loading,
    isAuthenticated,
  } =
    authContext;

  const handleConfirm = () => {
    if (lastPinData !== '') {
      const loginDataWithSessionDeletion = { pin: lastPinData, deleteSessions: true };
      login(loginDataWithSessionDeletion);
      closeSessionModal();
    }
  };


  const confirmLogin = (pin: string) => {
    setLastPinData(pin);
    const loginDataWithSessionDeletion = { pin: pin, deleteSessions: false, login_type: 'lock'};
    login(loginDataWithSessionDeletion);
  };

  useEffect(() => {
    const authorisationCode = params['code'];
    const state = params['state'];
    const redirectUri = params['redirect_uri'];

    const usedCode = localStorage.getItem('used_auth_code');
    if (authorisationCode && authorisationCode === usedCode) {
      navigate('/');
      return;
    }

    if (authorisationCode) {
      localStorage.setItem('used_auth_code', authorisationCode);
      removeSavedContractId();
      login({ code: authorisationCode, state, redirect_uri: redirectUri });
    }
  }, []);

  return (
    <div className={styles.container}>
      {loading && <div className={styles.centerSpinner}><Spinner /></div>}
      {showModal && !loading && (
        <SessionManagementModal centered={true} show={showModal} onHide={closeSessionModal} onConfirm={handleConfirm} />
      )}
      {
        !showModal && confirmPinRequired && !loading &&
        <PinModal error={error} confirmLogin={confirmLogin} />}
    </div>
  );
};

export default LoginResponse;
